// FutureLab
import { ChatListDataInterface, ChatListItemsDesktop } from './ChatListItemsDesktop';
import { LoggedInUserDetails } from '../../reducers/index';
import { UserDetailsListItem } from '../../model';
import { getQueryResults } from '../../utilities/Chat';

interface ChatListItemsDesktopLoopProps {
	chatListsItems: ChatListDataInterface[];
	loggedInUserDetails: LoggedInUserDetails;
	userListProfilesDetails: UserDetailsListItem[];
	filterQuery: string;
	targetRef: any;
	showMessagePreview?: boolean;
}

export function ChatListItemsDesktopLoop(chatListItemsDesktopLoop: ChatListItemsDesktopLoopProps) {
	const { chatListsItems, loggedInUserDetails, userListProfilesDetails, filterQuery, targetRef, showMessagePreview } =
		chatListItemsDesktopLoop;
	const results = getQueryResults(chatListsItems, loggedInUserDetails, userListProfilesDetails, filterQuery);

	const target = results.length - 1;
	return (
		<>
			{results.map((chatListItem: ChatListDataInterface, index: number) => {
				return (
					<ChatListItemsDesktop
						key={chatListItem.id}
						targetRef={index === target ? targetRef : null}
						chatListItem={chatListItem}
						showMessagePreview={showMessagePreview}
					></ChatListItemsDesktop>
				);
			})}
		</>
	);
}
